export default {
  ANNOUNCEMENT_CLOSED: {
    name: 'Announcement closed',
    required: ['announcementName']
  }
};
